import script from "./ImportTransactions.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportTransactions.vue?vue&type=script&setup=true&lang=js"

import "./ImportTransactions.vue?vue&type=style&index=0&id=6da07088&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6da07088"]])

export default __exports__